<template>
  <div id="page">
    <div class="cut">
      <vue-cropper
        ref="cropper"
        :img="option.img"
        :output-size="option.size"
        :output-type="option.outputType"
        :info="option.info"
        :full="option.full"
        :fixed="option.fixed"
        :fixed-number="option.fixedNumber"
        :can-move="option.canMove"
        :can-move-box="option.canMoveBox"
        :fixed-box="option.fixedBox"
        :original="option.original"
        :auto-crop="option.autoCrop"
        :auto-crop-width="option.autoCropWidth"
        :auto-crop-height="option.autoCropHeight"
        :center-box="option.centerBox"
        @real-time="realTime"
        :high="option.high"
        @img-load="imgLoad"
        mode="cover"
        :maxImgSize="option.max"
      ></vue-cropper>
    </div>

    <div class="mt-3">
      <b-button-group>
        <b-button @click="changeScale(1)" variant="danger">放大</b-button>
        <b-button @click="changeScale(-1)" variant="danger">缩小</b-button>
        <b-button @click="rotateLeft" variant="danger">左旋</b-button>
        <b-button @click="rotateRight" variant="danger">右旋</b-button>
        <b-button @click="refreshCrop" variant="danger">重置</b-button>
        <b-button variant="danger" @click="cropImage()">完成</b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import wx from "weixin-js-sdk";
import axios from "axios";
export default {
  name: "EditCardface",
  data() {
    return {
      imgPath: "",
      bankSerialNumber: "",
      bankCode: "",
      selectParam: null,
      cardOri: "",
      cardTheme: "",
      option: {
        img: "",
        size: 1,
        info: true,
        full: false,
        outputType: "png",
        canMove: true,
        fixedBox: true,
        original: false,
        canMoveBox: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        //autoCropWidth: 160,
        //autoCropHeight: 150,
        centerBox: true,
        high: true,
        max: 99999,
        fixed: true,
        fixedNumber: [16, 9],
      },
    };
  },

  methods: {
    // 实时预览函数
    realTime(data) {
      console.log(data);
    },

    imgLoad(msg) {
      console.log(msg);
    },

    wxJsSdk: function () {
      var that = this;
      var url = window.location.href.split("#")[0];
      var formData = new FormData();
      formData.append("shareUrl", url);
      //url: 'http://127.0.0.1:8081/initWXJSSDKConfigInfo',
      //url: 'https://cp.hengbao.net.cn/pay/order/wx/initWXJSSDKConfigInfo',
      axios({
        method: "post",
        url: "https://cp.hengbao.net.cn/pay/order/wx/initWXJSSDKConfigInfo",
        data: formData,
      })
        .then(function (response) {
          that.initWXJSSDKConfigInfo = JSON.stringify(response);
          var data = response.data;
          console.log(data.appid);
          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);
          wx.config({
            debug: false,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ["getLocalImgData"],
          });

          wx.ready(function () {
            console.log("wx ready");
            // setTimeout(function() {
            //   that.getLocalImgData();
            // }, 2000)
            that.getLocalImgData();
          });

          wx.error(function () {
            console.log("wx error");
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getLocalImgData: function () {
      var that = this;
      wx.getLocalImgData({
        localId: this.imgPath, // 图片的localID
        success: function (res) {
          var localData = res.localData;
          console.log(localData.indexOf("data:image"));
          if (localData.indexOf("data:image") != 0) {
            //判断是否有这样的头部
            localData = "data:image/jpeg;base64," + localData;
          }
          localData = localData
            .replace(/\r|\n/g, "")
            .replace("data:image/jgp", "data:image/jpeg");
          //第一个替换的是换行符，第二个替换的是图片类型，因为在IOS机上测试时看到它的图片类型时jgp，
          //这不知道时什么格式的图片，为了兼容其他设备就把它转为jpeg
          that.option.img = localData;
          //alert(that.option.img);
          //console.log('option.img:' + that.option.img)
        },
      });
    },
    cropImage: function () {
      // var canvas = this.cropper.getCroppedCanvas();
      // var dataURL = canvas.toDataURL('img/png', 0.3);
      // localStorage.setItem('destImg', dataURL);
      // this.toUploadCardface();

      var that = this;
      this.$refs.cropper.getCropData((data) => {
        console.log(data);
        localStorage.setItem("destImg", data);
        that.toUploadCardface();
      });
    },
    toUploadCardface() {
      var selectParam = JSON.stringify(this.selectParam);
      let cardThemeParam = JSON.stringify(this.cardTheme);
      this.$router.replace({
        name: "UploadCardface",
        params: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          selectParam: selectParam,
          cardOri: this.cardOri,
          cardTheme: cardThemeParam,
        },
      });
    },
    refreshCrop() {
      // clear
      this.$refs.cropper.refresh();
    },
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
  },
  mounted: function () {
    this.imgPath = this.$route.params.imagePath;
    console.log("imgPath:" + this.imgPath);
    this.bankSerialNumber = this.$route.params.bankSerialNumber;
    console.log("bankSerialNumber:" + this.bankSerialNumber);

    this.bankCode = this.$route.params.bankCode;
    console.log("bankCode:" + this.bankCode);

    var selectParam = this.$route.params.selectParam;
    console.log("selectParam:" + selectParam);
    if (selectParam !== undefined) {
      this.selectParam = JSON.parse(selectParam);
    }
    this.cardOri = this.$route.params.cardOri;
    console.log("cardOri:" + this.cardOri);

    if (this.cardOri == 0) {
      //横版
      this.option.fixedNumber = [16, 9];
    } else if (this.cardOri == 1) {
      //竖版
      this.option.fixedNumber = [9, 16];
    }

    let themeParam = this.$route.params.cardTheme;
    console.log("themeParam:" + themeParam);
    if (themeParam !== undefined) {
      this.cardTheme = JSON.parse(themeParam);
    }

    this.wxJsSdk();
  },
};
</script>

<style scoped>
.cut {
  width: 100vw;
  height: 80vh;
}

.test-button {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}

/* .btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #c0ccda;
    color: #1f2d3d;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 20px 10px 0px 0px;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: #50bfff;
    border-color: #50bfff;
    transition: all .2s ease;
    text-decoration: none;
    user-select: none;
  } */
</style>



// WEBPACK FOOTER //
// src/components/EditCardface.vue